import { render, staticRenderFns } from "./SociosFamilia.vue?vue&type=template&id=23112b1e&scoped=true&"
import script from "./SociosFamilia.vue?vue&type=script&lang=js&"
export * from "./SociosFamilia.vue?vue&type=script&lang=js&"
import style0 from "./SociosFamilia.vue?vue&type=style&index=0&id=23112b1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23112b1e",
  null
  
)

export default component.exports